import { Children, cloneElement, useRef, useState } from 'react'
import styled, { css } from 'styled-components'
import { Button, IconChevronDown } from '@machobear/design-system'
import noop from 'lodash/noop'

import { breakpoints, colors } from '@/styles'

const Wrapper = styled.div`
  position: relative;

  ${({ customStyle }) => customStyle}
`

const Clickable = styled.button`
  display: flex;
  align-items: center;
  height: 40px;
  border: 1.5px solid ${colors.blue16};
  border-radius: 4px;
  min-width: unset;
  padding: 12px 20px;
  color: ${colors.blue16};
  background-color: ${colors.white};
  cursor: pointer;
  transition: color 300ms ease-in-out 0s, background-color 300ms ease-in-out 0s,
    box-shadow 300ms ease-in-out 0s;

  &:hover {
    background-color: ${colors.grey96};
  }
  &:active {
    background-color: ${colors.grey88} !important;
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    height: unset;
    min-width: unset;
    padding: 0;
  }

  ${props =>
    props.noHand &&
    `
    cursor: default;
  `}

  ${props =>
    props.disabled &&
    `
    cursor: not-allowed !important;
    background: ${colors.lightGrey};
    opacity: 0.5;
  `}

  > svg {
    margin-right: 10px;
  }
`

const FilterModal = styled.div`
  pointer-events: auto;
  border-radius: 10px;
  position: absolute;
  top: 100%;
  left: -1px;
  width: calc(100% + 2px);
  z-index: 299;

  ${({ customStyle }) => customStyle}
`

const listCustomStyle = css`
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    border-left: none;
    border-right: none;
  }
`

const optionCustomStyle = css`
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    border-left: none;
    border-right: none;
  }
`

const FilterItem = ({
  customStyle = [],
  modalStyle = [],
  disabled,
  title,
  children,
  as
}) => {
  const [opened, setOpen] = useState()
  const node = useRef()
  const setRef = value => {
    node.current = value
  }
  const close = () => {
    setOpen(false)
  }
  const toggle = () => {
    setOpen(value => !value)
  }
  const handleClickOutside = e => {
    if (node?.current?.contains(e.target)) {
      return
    }
    close()
  }

  if (!children) {
    return (
      <Wrapper customStyle={customStyle}>
        <Clickable disabled={disabled} noHand as={as} />
      </Wrapper>
    )
  }
  return (
    <Wrapper customStyle={customStyle}>
      <div ref={setRef}>
        <Button
          variant="ghost"
          icon={<IconChevronDown />}
          iconPosition="trailing"
          disabled={disabled}
          onClick={disabled ? noop : toggle}
          as={as}
        >
          {title}
        </Button>
        {opened && (
          <FilterModal customStyle={modalStyle}>
            {Children.map(children, child =>
              cloneElement(child, {
                clickOutsideCallback: handleClickOutside,
                customStyle: listCustomStyle,
                optionCustomStyle,
                close,
                onChange: (...args) => {
                  child.props.onChange(...args)
                  close()
                }
              })
            )}
          </FilterModal>
        )}
      </div>
    </Wrapper>
  )
}

export default FilterItem
